import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

import CustomLink from '@shared/components/customLink'

function HeaderCardsHeader({ data = [], i18nKeyText = false }) {
  return (
    <div className={`${styles.headerContainer} d-flex align-items-start`}>
      <div className={styles.titleWrapper}>
        <h4 className={`${styles.h4MarginBtm}`}>{data.title}</h4>
        <span className={styles.titleBar} />
      </div>
      {Object.entries(data?.routeLinks || {}).length > 0 && (
        <div className={`${styles.scorecardNav}`}>
          {Object.entries(data?.routeLinks || {}).map(([key, href], idx) => {
            const label = key.charAt(0).toUpperCase() + key.slice(1)
            return (
              <CustomLink key={`header-button-${idx}`} href={href} prefetch={false}>
                <a className={styles.headerButton}>{label}</a>
              </CustomLink>
            )
          })}
        </div>
      )}
      {data?.slug && data?.readMoreText && (
        <CustomLink href={data.slug} prefetch={false}>
          <a className={styles.readMore}>{data.readMoreText} &rarr;</a>
        </CustomLink>
      )}
    </div>
  )
}

HeaderCardsHeader.propTypes = {
  data: PropTypes.object,
  i18nKeyText: PropTypes.bool
}

export default HeaderCardsHeader
